import React, { Component } from 'react';
import { StyleRoot } from 'radium';
import Timeline from 'react-dual-timeline';
import 'font-awesome/css/font-awesome.min.css';
import MailingList from '../components/MailingList';
export default class Time extends Component {
  render() {
    const config = {
      // global
      paddingTop: 10,
      mediaWidthMed: 9000,
      mediaWidthSmall: 700,
      activeColor: 'rgb(240, 240, 240)',
      color: 'black',
      twoSidedOverlap: 10, // negative overlap between items if two-sided
      animations: true,
      addEvenPropToChildren: false,

      // line
      lineColor: '#757575',
      circleWidth: 30,
      paddingToItem: 50,
      paddingToItemSmall: 20,
      lineWidth: 5,

      // triangle
      triangleWidth: 16,
      triangleHeight: 8,

      // list item content
      itemWidth: 100,
      itemWidthMed: 100,
      offsetHidden: 200,
      triangleOffset: 7,
      smallItemWidthPadding: 20,
      itemPadding: 10,
      evenItemOffset: -30, // important when using bootstrap.css
    };
    if (this.props.intro) {
      return (
        <div>
          <StyleRoot>
            <Timeline {...config}>
              <div icon="1">
                <h5>
                  <a href="/how-much-can-you-get">Can you afford a house?</a>
                </h5>
              </div>
              <div icon="...">
                <h5>
                  <a href="/walkthrough">View more... </a>
                </h5>
              </div>
            </Timeline>
          </StyleRoot>
        </div>
      );
    }

    return (
      <div>
        <h4>Not sure where to start?</h4>
        <p>
          Follow this timeline to lead you from thinking about buying, through to what to do after you successfully make
          a purchase
        </p>
        <StyleRoot>
          <Timeline {...config}>
            <div icon="1">
              <h5>
                <a href="/how-much-can-you-get">Can you afford a house?</a>
              </h5>
            </div>
            <div icon="2">
              <h5>
                <a href="/steps-to-buy">Steps to buying</a>
              </h5>
            </div>
            <div icon="3">
              <h5>
                <a href="/ways-to-purchase">Ways of Purchasing</a>
              </h5>
            </div>
            <div icon="4">
              <h5>
                <a href="/valuation">How to value property</a>
              </h5>
            </div>
            <div icon="5">
              <h5>
                <a href="/putting-in-an-offer">How to make an offer</a>
              </h5>
            </div>
            <div icon="6">
              <h5>
                <a href="#">Types of ownership (coming soon)</a>
              </h5>
            </div>
            <div icon="7">
              <h5>
                <a href="#">Who do you need to talk to? (coming soon)</a>
              </h5>
            </div>
            <div icon="8">
              <h5>
                <a href="#">Extra Tips and Tricks (coming soon)</a>
              </h5>
            </div>
          </Timeline>
        </StyleRoot>
        <div className="row">
          <div className="col-md-12 info">
            <br />
            <MailingList />
            <p align="center">
              Or <a href="/contact">contact us</a> if you have any requests
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Timeline.jsx